<template>
  <div class="ushk-chart">
    <chart v-for="type in types" :key="type.code" :name="type.name" :code="type.code"></chart>
  </div>
</template>
<script>
  import Chart from './Chart'
  export default {
    components: {
      Chart
    },
    data () {
      return {
        types: [
          {name: '道琼斯', code: 'dowi'},
          {name: '纳斯达克', code: 'nasx'},
          {name: '标普500', code: 'spx500'}
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ChartGroup.vue?0eca0fba